import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=16564f88&scoped=true&"
import script from "./CustomerSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelector.vue?vue&type=style&index=0&id=16564f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16564f88",
  null
  
)

export default component.exports